// extracted by mini-css-extract-plugin
export default {"FolderButton":"newfolderbutton_FolderButton__P085B"};